import {RenderV2_DisplayItem} from '../render-v2-d';

/**
 * CSS grid lines for one display item.
 * `rowStart` and `columnStart` are one-based starting lines, not track spans:
 * a column start of 2 becomes `grid-column: 2`, a single cell in column 2.
 * A falsy start (0, NaN, or missing) falls back to line 1.
 */
export const displayItemGridLines = (item: Pick<RenderV2_DisplayItem, 'rowStart' | 'columnStart'>): {gridRow: string; gridColumn: string} => ({
    gridRow: `${item.rowStart || 1}`,
    gridColumn: `${item.columnStart || 1}`,
});
